var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5013 33.5013L27.8103 27.7512M27.4512 10.0966C32.2421 14.8875 32.2421 22.6603 27.4512 27.4512C24.0239 30.8785 16.2512 33.6058 10.0966 27.4512C5.30113 22.6603 5.30113 14.8875 10.0966 10.0966C14.8875 5.30113 22.6603 5.30113 27.4512 10.0966Z",
    stroke: "#242628",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8828 15.8833L21.6647 21.6651",
    stroke: "#242628",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8828 21.6651L21.6647 15.8833",
    stroke: "#242628",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNoData);
export default __webpack_public_path__ + "static/media/ico-noData.1786dfed81cf3b723aef49f9ee08d226.svg";
export { ForwardRef as ReactComponent };